"use client";

import { PassType, PASSES } from "@/types/pass";
import { cn } from "@/lib/utils";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

// 멤버십 배지 설정
const MEMBERSHIP_BADGES: Record<PassType, { label: string; className: string }> = {
  free: {
    label: "감자단",
    className: "bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200",
  },
  starter: {
    label: "찐감자단",
    className: "bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200",
  },
  premium: {
    label: "고오급감자단",
    className: "bg-amber-100 dark:bg-amber-900 text-amber-800 dark:text-amber-200",
  },
  complete: {
    label: "풀세트감자단",
    className: "bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200",
  },
  intelligence: {
    label: "풀세트+AI감자단",
    className: "bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200",
  },
};

// passType에 따른 팝오버 메시지 생성
function getPopoverMessage(passType: PassType): string {
  const passInfo = PASSES[passType];
  if (passType === 'free') {
    return "무료 이용권 유저입니다";
  }
  return `${passInfo.name} 이용권 유저입니다`;
}

interface MembershipBadgeProps {
  passType?: PassType | null;
}

/**
 * 멤버십 배지 컴포넌트
 * 클릭 시 이용권 정보를 팝오버로 표시
 */
export default function MembershipBadge({ passType }: MembershipBadgeProps) {
  const type = passType || 'free';
  const badge = MEMBERSHIP_BADGES[type];
  const popoverMessage = getPopoverMessage(type);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={cn(
            "text-xs px-2 py-0.5 rounded-full cursor-pointer hover:opacity-80 transition-opacity",
            badge.className
          )}
        >
          {badge.label}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto max-w-xs p-3">
        <p className="text-sm text-center">{popoverMessage}</p>
      </PopoverContent>
    </Popover>
  );
}
